import styled, { css } from "styled-components";
import logoFundo from "assets/svg/logo-fundo-color.svg";

export const Wrapper = styled.div`
  ${({ theme }) => css`
    font-family: ${theme.font.family.default};
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    
    /* 1. Base background color stays on the main container */
    background-color: white; 
    position: relative; /* Required to anchor the absolute pseudo-element */
    overflow: hidden;

    /* 2. Create a separate layer just for the background image */
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 0; /* Keeps it behind your text/cards */
      
      /* Move your background image properties here */
      background-image: url(${logoFundo});
      background-repeat: no-repeat;
      background-position: left center;
      background-size: contain;
      
      /* 3. Control the image opacity here (e.g., 30% visible) */
      opacity: 0.25; 
    }

    /* 4. Force all children components to sit safely on top of the image */
    > * {
      position: relative;
      z-index: 1;
    }
  `}
`;

export const Header = styled.div`
  ${({ theme }) => css`
    width: 100vw;
    top: 0px;
    position: absolute;
    display: flex;
    align-items: right;
    justify-content: space-between;
    padding: 0 0 0 40px;
    // background-color: ${theme.colors.blue700};
    background-color: #202C4E;
  `}
`;

export const Card = styled.div`
  ${({ theme }) => css`
    .logo-p3m {
      width: 65%;
    }

    padding: 80px 0 80px 0;


    height: 500px;
    width: 700px;

    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: ${theme.colors.white};
    justify-content: space-around;

    border-radius: 0.375rem;
    box-shadow: 0 10px 10px rgba(0, 0, 0, 0.1);
  `}
`;

export const Buttons = styled.div`
  display: flex;
  flex-direction: column;

  gap: 1rem;
  width: 65%;
  height: max-content;
  flex-shrink: 0;
`;

const BaseLoginButton = styled.button`
  ${({ theme }) => css`
    appearance: none;
    align-items: center;
    background-color: ${theme.colors.gray50};
    border: 0;
    border-radius: 999em;
    box-sizing: border-box;
    color: ${theme.colors.blue700};
    cursor: pointer;
    display: inline-flex;
    font-family: Rawline, Raleway, sans-serif;
    font-size: 16.8px;
    font-weight: 600;
    height: 48px;
    justify-content: center;
    line-height: 1.45;
    margin: 0;
    overflow: hidden;
    padding: 0 16px;
    position: relative;
    text-align: center;
    text-decoration: none;
    vertical-align: middle;
    white-space: nowrap;
    width: 100%;

    &:focus {
      outline: none;
    }

    &:focus-visible {
      outline: 2px dashed #ffcd07;
      outline-offset: 4px;
    }

    &:hover:not(:disabled) {
      background-color: #d3dded;
    }

    &:active:not(:disabled) {
      background-color: #91add9;
    }

    &:disabled {
      cursor: not-allowed;
      opacity: 0.45;
    }
  `}
`;

export const GovLoginButton = styled(BaseLoginButton)`
  img {
    max-height: 20px;
    width: auto;
    margin-left: 4px;
  }
`;

export const LoginButton = styled(BaseLoginButton)`
  ${({ theme, disabled }) => css`
    padding: 10px;
    gap: 0.75rem;

    display: flex;
    align-items: center;
    justify-content: center;

    font-weight: ${theme.font.weights.bold};

    color: ${disabled ? theme.colors.gray200 : 'inherit'};

    .public-access-info {
      display: inline-flex;
      align-items: center;
      position: absolute;
      right: 10px;
      color: ${disabled ? theme.colors.gray200 : '#202c4e'};

      svg {
        font-size: 24px;
      }
    }
  `}
`;

export const LoginButtonLabel = styled.span<{ $desktop?: boolean }>`
  display: inline;

`;

export const Error = styled.div`
  margin-bottom: 0.25rem;
  padding: 1.2rem;
  border-radius: 0.375rem;
  background: #fff0f0;
  color: #b42318;
  font-size: 1.4rem;
  text-align: center;
`;

export const Footer = styled.footer`
  ${({ theme }) => css`
    width: 75%;
    height: 5px;
    // background-color: ${theme.colors.blue700};
    background-color: #202C4E;
    position: absolute;
    bottom: 50px;
  `}
`;
